<div class="password__group">
  <div *ngIf="!saved">
    <h2 translate>Change password</h2>
    <kpd-alert type="error" *ngIf="user.key && !isLocalUser" icon="error-standard" translate>
      Only the password of local users can be changed.
    </kpd-alert>
    <app-change-password-form-group
      (loadingChanged)="loading = $event"
      [userKey]="userKey"
      *ngIf="isLocalUser"
      (passwordChanged)="onPasswordChanged()"
    ></app-change-password-form-group>
    <br />
    <button type="button" [disabled]="loading" class="button button--main" *ngIf="isLocalUser" (click)="onSubmit()">
      <span *ngIf="!loading" translate>Change</span><span *ngIf="loading" translate>Processing</span>
    </button>
  </div>
  <div *ngIf="saved">
    <h2 translate>Password changed</h2>
    <p translate>Your password is succesfully changed.</p>
  </div>
</div>
